export default __webpack_public_path__ + "static/media/sort-up.992e7ba7.svg";